export const getTypeFieldNameFactory = <T>(): any => {
    return (name: keyof T) => name;
};
